import { createApp } from 'vue'
import TDesign from 'tdesign-vue-next'
import { MotionPlugin } from '@vueuse/motion'

import 'tdesign-vue-next/es/style/index.css'
import '../styles/tailwind.css'

// FontAwesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
    faGaugeHigh, faCircleCheck, faClipboardList, faListCheck, faFile,
    faCopy, faLayerGroup, faCircleExclamation, faLink, faUsers,
    faBoxOpen, faFlask, faUser, faCalendarDays, faFileLines,
    faClock, faRightFromBracket, faStar, faGear, faTableCells,
    faSitemap, faDiagramProject, faWarehouse, faRightLeft,
    faQrcode, faMagnifyingGlass, faIndustry, faPen, faBoxesPacking,
    faServer, faListUl, faWrench, faBars, faChevronLeft, faChevronRight,
    faBell, faGlobe, faChevronDown, faSearch, faPowerOff, faSlash,
    faHouse, faCircleInfo, faFileExport, faBoxesStacked,
    faUserGear, faBook,
} from '@fortawesome/free-solid-svg-icons'

library.add(
    faGaugeHigh, faCircleCheck, faClipboardList, faListCheck, faFile,
    faCopy, faLayerGroup, faCircleExclamation, faLink, faUsers,
    faBoxOpen, faFlask, faUser, faCalendarDays, faFileLines,
    faClock, faRightFromBracket, faStar, faGear, faTableCells,
    faSitemap, faDiagramProject, faWarehouse, faRightLeft,
    faQrcode, faMagnifyingGlass, faIndustry, faPen, faBoxesPacking,
    faServer, faListUl, faWrench, faBars, faChevronLeft, faChevronRight,
    faBell, faGlobe, faChevronDown, faSearch, faPowerOff, faSlash,
    faHouse, faCircleInfo, faFileExport, faBoxesStacked,
    faUserGear, faBook,
)

import App from './App.vue'
import router from '../core/router'
import store from '../core/store'
import i18n from '../i18n'

// Keep dayjs aligned with the selected UI language while still showing Jakarta local time.
import dayjs from 'dayjs'
import 'dayjs/locale/en'
import 'dayjs/locale/id'

const initialLang = (localStorage.getItem('lang') || 'en').toLowerCase()
dayjs.locale(initialLang.startsWith('id') ? 'id' : 'en')

const app = createApp(App)

app.use(TDesign)
app.use(MotionPlugin)
app.component('font-awesome-icon', FontAwesomeIcon)
app.use(i18n)
app.use(store)
app.use(router)

app.mount('#app')
